import React, { useState, useEffect } from 'react';
import './Registration.css';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import { useSettings } from '../context/SettingsContext';

function ServiceCard({ id, title, description, features, price, onAddToCart, onRemoveFromCart, isInCart }) {
  const { currencySymbol } = useSettings();
  
  return (
    <div className="registration-card">
      <h3>{title}</h3>
      <div className="price">{currencySymbol}{price}</div>
      <p className="service-description">{description}</p>
      <ul className="features-list">
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
      {isInCart ? (
        <button 
          className="select-plan remove-btn"
          onClick={() => onRemoveFromCart(id)}
        >
          Remove from Cart
        </button>
      ) : (
        <button 
          className="select-plan"
          onClick={() => onAddToCart({ id, name: title, price })}
        >
          Add to Cart
        </button>
      )}
    </div>
  );
}

function Registration() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { addToCart, removeFromCart, isInCart } = useCart();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/registration`);
        
        // Add unique IDs to each service
        if (response.data && response.data.services) {
          response.data.services = response.data.services.map((service, index) => ({
            ...service,
            id: `registration-${index}`
          }));
        }
        
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
  };

  const handleRemoveFromCart = (itemId) => {
    removeFromCart(itemId);
    // Optional: Show a confirmation message
    alert(`Item removed from cart!`);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  if (!data) {
    return <div className="error">No data available</div>;
  }

  return (
    <div className="registration-page">
      <section className="registration-hero">
        <h1>{data.hero.title}</h1>
        <p className="hero-subtitle">{data.hero.subtitle}</p>
      </section>

      <section className="services-section">
        <div className="services-grid">
          {data.services.map((service, index) => (
            <ServiceCard key={index} id={service.id} title={service.title} description={service.description} features={service.features} price={service.price} onAddToCart={handleAddToCart} onRemoveFromCart={handleRemoveFromCart} isInCart={isInCart(service.id)} />
          ))}
        </div>
      </section>

      <section className="benefits-section">
        <h2>Why Choose Our Registration Services?</h2>
        <div className="benefits-grid">
          {data.benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="contact-section">
        <h2>Ready to Register Your Business?</h2>
        <p>Contact us for expert guidance on business registration</p>
        <div className="contact-info">
          <p>Email: <a href={`mailto:${data.contact.email}`}>{data.contact.email}</a></p>
          <p>Phone: <a href={`tel:${data.contact.phone.replace(/\s+/g, '')}`}>{data.contact.phone}</a></p>
        </div>
      </section>
    </div>
  );
}

export default Registration; 